import React, { useState, useEffect } from 'react';
import {
    Paper,
    Typography,
    Grid,
    TextField,
    Button,
    Divider,
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { updateEventAttribute, updateEventObject } from '../../../../data-store/actions/events-actions';

const ConfiguracionItems = ({ itemsActuales = {}, eventDetail }) => {
    const [items, setItems] = useState({});
    const dispatch = useDispatch();

    useEffect(() => {
        setItems(itemsActuales || {});
    }, [itemsActuales]);

    const handleChange = (code, field, value) => {
        setItems((prev) => ({
            ...prev,
            [code]: {
                ...prev[code],
                [field]: value,
            },
        }));
    };

    const agregarNuevoItem = () => {
        const nuevoCode = `item_${Date.now()}`;
        setItems((prev) => ({
            ...prev,
            [nuevoCode]: {
                code: nuevoCode,
                name: '',
                description: '',
                itemOrder: 'insc',
                itemForm: [],
            },
        }));
    };

    const eliminarItem = (code) => {
        const copia = { ...items };
        delete copia[code];
        setItems(copia);
    };

    const guardarCambios = () => {
        console.log("items", items)
        dispatch(
            updateEventObject(
                "evento_" + eventDetail.iDEvento,
                "inscripcionesConfiguracion/configuracion/entregaKits/items/",
                items
            )
        );
    };


    return (
        <Paper style={{ padding: 24, marginTop: 24 }}>
            <Typography variant="h6" gutterBottom>
                Estaciones de entrega (Items)
            </Typography>
            <Divider style={{ margin: '16px 0' }} />

            {Object.entries(items).map(([code, item]) => (
                <Grid container spacing={2} key={code} style={{ marginBottom: 16 }}>
                    <Grid item xs={12} sm={10}>
                        <TextField
                            label="Nombre"
                            value={item.name}
                            onChange={(e) => handleChange(code, 'name', e.target.value)}
                            fullWidth
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        {code !== 'item_1' && (
                            <Grid item xs={12} sm={1}>
                                <Button
                                    color="secondary"
                                    onClick={() => eliminarItem(code)}
                                    variant="outlined"
                                >
                                    Eliminar
                                </Button>
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            ))}

            <Button onClick={agregarNuevoItem} color="primary" variant="contained">
                Agregar nuevo item
            </Button>

            <Button
                onClick={guardarCambios}
                color="primary"
                variant="outlined"
                style={{ marginLeft: 16 }}
            >
                Guardar cambios
            </Button>
            <Typography variant="subtitle1" gutterBottom>
                Nota: Agregar items adicionales aplica solo si van a marcar en la aplicación la entrega en específico de ese item
            </Typography>

        </Paper>
    );
};

export default ConfiguracionItems;
